import React, { useState } from "react";
import { downloadAction } from "../../../../utils/downloadMaster";

export default function DownloadMastersButton({
  masterList = [],
  company_id,
  type,
  totalCount = -1
}) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await downloadAction(type, company_id, totalCount, "company");
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="btn btn-sm btn-primary ms-2"
      disabled={masterList.length === 0 || isDownloading}
    >
      <i className="fa fa-download mr-2" />{" "}
      {isDownloading ? "Downloading..." : "Download"}
    </button>
  );
}
